import type { FaireProductEntity } from "../../entity_types/product";

export const p_pya9runhnt: FaireProductEntity = {
  token: "p_pya9runhnt",
  type: "product",
  name: "The Club Cardigan (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/9928bbacf5ccc1694c634ea4c80efa7f657073182c3c4b54f7953e127a422ece.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bbb9f23026a5c5edb9cfd61e8690e069f6ec80d104ee498662bafa8195be5120.jpeg",
    "https://cdn.faire.com/fastly/d07b47d748fb022c1d7817af6d637aea02cec7b9bf109eda039284a7d6eaf221.jpeg",
    "https://cdn.faire.com/fastly/c4fbcc3899479de5428903c89c4e44b3e46e880b1720867ad0d1cb2798608595.jpeg",
    "https://cdn.faire.com/fastly/c75e8a3dfa20a48c97c15ed8247b70a8fd96719fa595627dad79fec884eb48e9.jpeg",
    "https://cdn.faire.com/fastly/e410cc4a068a4a04c37c16658eb092821920045e4dac5709326f3fae7a0ea5d5.jpeg",
    "https://cdn.faire.com/fastly/7f9bc0849a3f74cde1a83d88377f7e7fb97aa4d3b23bc29797f19c0c3200aa06.jpeg",
    "https://cdn.faire.com/fastly/d331db600c541c069072acfb00c9798ef60ae60a8b305a26c10799660b6f80a9.jpeg",
    "https://cdn.faire.com/fastly/95fc45e1a400ea31c59cbb0f21cf620b85ff1d1ad6b9e257510175a98f81e5f5.jpeg",
    "https://cdn.faire.com/fastly/cc1d551106e5291ff2ea43f785afc1f813fbcdad63da8fceb4f9ef9ddeaecb13.jpeg",
  ],
  priceDollars: 280,
  description:
    'Why we made this?\n\nAll the coziness of a knit with a light feel, the Club Cardigan is an effortless layering piece with a classic design. Made from breathable, lightweight cotton, it offers an airy quality similar to the Milo Sweater, but with a silhouette that features a gentle, fluid drape. A clean collar sits atop a functional front finished with authentic shell buttons, while an easy drop shoulder and tapered sleeves perfectly balance the slightly cropped length.\n\n\n\n\nContents: \n\n100% Cotton\n\n\nMade in South Korea\n\n\n\nCare Instructions:\n\nHand wash in cold water\n\nTowel dry & lay flat to dry\n\n\n\nApproximate Measurements: \n\nXS/S: Length 21", Chest 21 1/4"\n\nM/L: Length: 21 1/2", Chest: 22 3/4" \n\n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip:36" and wearing a size XS/S \n\n\n\nMSRP: $140 USD\n',
  tags: [],
  msrpDollars: 560,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:02.293Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
